module.exports = __webpack_public_path__ + "img/koi.97bd66e0.png";